import * as React from 'react';
import sanitizedHTML from 'sanitize-html';
import LocalizationService from '../../Services/Services.Secondary/Localization/LocalizationService';

let resx = LocalizationService.getInstance();

//Resource strings
let ViewMore_text = resx.getLocalizedResource('ViewMore_text');
let Showless_text = resx.getLocalizedResource('Showless_text');

interface ICollapsingElementBoxProps {
  HtmlString: string;
  MaxLinesBeforeCollapsing: number;
}

interface ICollapsingElementBoxState {
  numberOfLines: number;
  isCollapsed: boolean;
}

export default class CollapsingElementBox extends React.Component<
  ICollapsingElementBoxProps,
  ICollapsingElementBoxState
> {
  private displayElement: React.RefObject<HTMLDivElement>;
  constructor(props: ICollapsingElementBoxProps) {
    super(props);
    this.displayElement = React.createRef();
    this.state = {
      numberOfLines: -1,
      isCollapsed: true,
    };
  }

  componentDidMount() {
    var elementHeight = this.displayElement?.current?.getBoundingClientRect().height;
    var elementLineHeight = parseFloat(getComputedStyle(this.displayElement.current as HTMLDivElement).fontSize);
    if (elementHeight && elementLineHeight > 0) {
      this.setState({ numberOfLines: elementHeight / elementLineHeight });
    }
  }

  private toggleCollapse() {
    this.setState({ isCollapsed: !this.state.isCollapsed });
  }

  public render() {
    let { HtmlString } = this.props;
    return (
      HtmlString && (
        <div>
          {(() => {
            if (this.state.numberOfLines > this.props.MaxLinesBeforeCollapsing) {
              return (
                <span>
                  {(() => {
                    if (!this.state.isCollapsed) {
                      return (
                        <div>
                          <div
                            ref={this.displayElement}
                            dangerouslySetInnerHTML={{ __html: sanitizedHTML(this.props.HtmlString) }}
                          />
                          <button
                            style={{ border: 'none', padding: '0px', minWidth: '100px' }}
                            onClick={() => this.toggleCollapse()}
                          >
                            <a data-toggle="tab">
                              <div style={{ display: 'inline' }}>
                                {'... '}
                                {Showless_text}
                              </div>
                            </a>{' '}
                          </button>
                        </div>
                      );
                    } else {
                      return (
                        <div>
                          <div
                            ref={this.displayElement}
                            style={{
                              height: this.props.MaxLinesBeforeCollapsing.toString() + 'em',
                              overflow: 'hidden',
                            }}
                          >
                            <div dangerouslySetInnerHTML={{ __html: sanitizedHTML(this.props.HtmlString) }} />
                          </div>
                          <button
                            style={{ border: 'none', padding: '0px', minWidth: '100px' }}
                            onClick={() => this.toggleCollapse()}
                          >
                            <a data-toggle="tab">
                              <div style={{ display: 'inline' }}>
                                {'... '}
                                {ViewMore_text}
                              </div>
                            </a>
                          </button>
                        </div>
                      );
                    }
                  })()}
                </span>
              );
            } else {
              return (
                <span>
                  <div
                    ref={this.displayElement}
                    dangerouslySetInnerHTML={{ __html: sanitizedHTML(this.props.HtmlString) }}
                  />
                </span>
              );
            }
          })()}
        </div>
      )
    );
  }
}
